<template>
  <div>
    <div
      id="wrapper-ticket-items"
      v-resize="onResizeWrapperTicket"
      style="overflow-y: auto; min-height: 300px"
      class="pa-4"
      :style="{ height: wrapper_ticket_height + 'px' }"
      @scroll="onUserScroll"
    >
      <div v-if="filteredTickets && filteredTickets.length">
        <template v-for="(ticket, index) in filteredTickets">
          <ticket-item
            :key="index"
            :value="ticket"
            :pageid="pageid"
            @editTicketSuccess="onEditTicketSuccess"
          ></ticket-item>
        </template>
      </div>

      <div v-if="loading" class="text-xs-center pa-4">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
      </div>
      <div
        v-else-if="!filteredTickets || (filteredTickets && filteredTickets.length == 0)"
        class="text-xs-center"
      >
        <h1>ไม่พบข้อมูล</h1>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import TicketItem from './TicketItem'
const LIMIT = 20
export default {
  components: {
    TicketItem
  },
  props: ['value', 'byadminid', 'filter', 'pageid'],
  data() {
    return {
      loading: true,
      tickets: [],
      timer: null,
      offset: 0,
      current_page: 1,
      total_tickets: 0,
      wrapper_ticket_height: window.innerHeight * 0.6
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      currentUserTicketLoading: 'currentUserTicketLoading'
    }),
    filteredTickets() {
      var result
      if (this.$store.state.privilege) {
        if (this.selectedBot.theme == 'seagull') {
          result = this.tickets
        } else if (
          this.selectedBot.theme == 'ticket' ||
          this.$store.state.ticketThemeList.includes(this.selectedBot.theme) ||
          this.$store.state.ticketPageid.includes(this.selectedBot.pageid) ||
          ['gpf', 'mtc'].includes(this.selectedBot.type) ||
          this.selectedBot.unlock_ticket_3
        ) {
          switch (this.$store.state.privilege.view_ticket) {
            case 'all':
              result = this.tickets
              break
            case 'only_me':
              result = this.tickets.filter((el) => {
                return el.assignadminid == this.$store.state.userid
              })
              break
            case 'only_group':
              result = this.tickets.filter((el) => {
                return el.assigngroupid == this.$store.state.admingroupid
              })
              break
            case 'only_subgroup':
              result = this.tickets.filter((el) => {
                return el.assignsubgroupid == this.$store.state.adminsubgroupid
              })
              break
            default:
              result = []
          }
        } else if (
          ['studio7', 'ticket2', 'ustore', 'tdtawandang', 'cityfresh'].includes(
            this.selectedBot.theme
          ) ||
          [...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)
        ) {
          // if (['superadmin', 'systemadmin'].includes(this.$store.state.privilege.role)) {
          result = this.tickets
          // } else {
          //   result = this.tickets.filter(el => {
          //     return el.assignadminid == this.$store.state.userid
          //   })
          // }
        }
      } else {
        result = []
      }
      if (this.filter) {
        result = result.filter((el) => el.status == this.filter)
      }
      return result
    }
  },
  watch: {
    currentUserTicketLoading(newVal) {
      alert(newVal)
    }
  },
  async mounted() {
    const vm = this
    this.$root.$on('loadTicket', () => {
      this.initTicketList()
    })
    vm.initTicketList()
    vm.onResizeWrapperTicket()
  },
  methods: {
    async initTicketList() {
      try {
        await this.fetchTicket()

        this.$store.dispatch('loadAgentGroups')
        this.$store.dispatch('loadAgentSubGroups')
        this.$store.dispatch('loadAgents')
      } catch (error) {
        console.error(error)
      }
    },
    async fetchTicket() {
      const vm = this
      let filter = {}
      try {
        vm.loading = true
        if (vm.$store.state.privilege) {
          const view_ticket = vm.$store.state.privilege.view_ticket
          if (view_ticket == 'all') {
            // dont do shit
          } else if (view_ticket == 'only_me') {
            Object.assign(filter, {
              assignadminid: vm.$store.state.userid
            })
          } else if (view_ticket == 'only_group') {
            Object.assign(filter, {
              assigngroupid: vm.$store.state.admingroupid
            })
          } else if (view_ticket == 'only_subgroup') {
            Object.assign(filter, {
              assignsubgroupid: vm.$store.state.adminsubgroupid
            })
          }
        }

        let response
        if (vm.byadminid) {
          response = await vm.getTicketByAdminId()
        } else {
          response = await vm.getTicketListByUser(filter)
        }

        if (response.data && response.data.length > 0) {
          vm.tickets = [...vm.tickets, ...response.data]
          vm.$store.commit('SET_TICKET_LOADING', false)
          vm.$store.commit('SET_CURRENT_USER_TICKET', vm.tickets)
          vm.total_tickets = Number(response.total ? response.total : 0)
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.loading = false
      }
    },

    onResizeWrapperTicket: function () {
      const vm = this
      vm.$nextTick(function () {
        if (document.getElementById('chattype')) {
          vm.wrapper_ticket_height =
            window.innerHeight -
            document.getElementById('main_toolbar').clientHeight -
            document.getElementById('chattool').clientHeight
        }
      })
    },
    getTicketListByUser(filter = {}) {
      const data = {
        userid: this.value,
        pageid: this.pageid,
        limit: LIMIT,
        offset: this.offset,
        ...filter
      }
      return new Promise((resolve, reject) => {
        api.getTicketListByUser(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    onUserScroll: async function () {
      const vm = this
      // eslint-disable-next-line no-undef
      const messages = $('#wrapper-ticket-items')
      const scrollPosition = messages.scrollTop()
      const chatboxHeight = messages.outerHeight(true)
      const totalHeight = messages.prop('scrollHeight')
      if (!vm.loading && Math.abs(Math.round(scrollPosition + chatboxHeight) - totalHeight) < 3) {
        if (vm.total_tickets > LIMIT * vm.current_page) {
          vm.offset = vm.current_page * LIMIT
          vm.current_page = vm.current_page + 1
          await vm.$nextTick()
          vm.fetchTicket()
        }
      }
    },
    getTicketByAdminId() {
      const data = {
        adminid: this.value,
        pageid: this.selectedBot.pageid,
        limit: LIMIT,
        offset: this.offset
      }
      return new Promise((resolve, reject) => {
        api.getTicketByAdminId(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onEditTicketSuccess(ticket) {
      const vm = this
      vm.offset = 0
      vm.current_page = 1
      vm.tickets = []
      await vm.$nextTick()
      vm.fetchTicket()
      if (ticket.status.toLowerCase().includes('closed')) {
        vm.$store.dispatch('handleRemoveUserFromAdminTap', {
          user_id: ticket.userid,
          pageid: vm.pageid,
          type: 'admin'
        })
        vm.$store.dispatch('handleUpdateLivechatUser', {
          user_id: ticket.userid,
          type: 'admin',
          data: {
            context: ''
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/TicketList.vue